import type { ComponentProps } from 'react';
import React from 'react';

import { LoadingAnimation as GarnishLoadingAnimation } from '@sg/garnish';

import { NAVBAR_HEADER_HEIGHT, TAB_BAR_HEIGHT } from '@order/navigation';

export const LoadingAnimation = (props: ComponentProps<typeof GarnishLoadingAnimation>) => {
  return (
    <GarnishLoadingAnimation
      {...props}
      topOffset={NAVBAR_HEADER_HEIGHT}
      bottomOffset={TAB_BAR_HEIGHT}
    />
  );
};
